var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush } from "./utils";
var dataToDataLayer = function (specificEventData) {
    var dlData = normalizeObject(__assign({ event_category: "feed_card" }, specificEventData));
    dataLayerPush(dlData);
};
var feedCardInteraction = function (e) {
    var eventData = (e === null || e === void 0 ? void 0 : e.detail) || {};
    dataToDataLayer({
        event: "feed_card_interaction",
        event_action: eventData["card_type"] + "_interaction",
        event_label: eventData["event_label"],
        non_interaction: true,
        supporter_id: eventData["supporter_number"],
        card_title: eventData["card_title"],
        card_type: eventData["card_type"],
        card_position: eventData["card_position"],
    });
};
var feedCardView = function (e) {
    var eventData = (e === null || e === void 0 ? void 0 : e.detail) || {};
    dataToDataLayer(__assign({ event: "feed_card_view", event_action: eventData["card_id"] + ":" + eventData["card_type"] + "_impression", event_label: eventData["event_label"], non_interaction: true, supporter_id: eventData["supporter_number"], card_title: eventData["card_title"], card_type: eventData["card_type"], card_position: eventData["card_position"] }, (eventData["event_category"] ? { event_category: eventData["event_category"] } : {})));
};
var feedCardClick = function (e) {
    var eventData = (e === null || e === void 0 ? void 0 : e.detail) || {};
    dataToDataLayer(__assign({ event: "feed_card_click", event_action: eventData["card_type"] + "_click", event_label: eventData["event_label"], non_interaction: true, supporter_id: eventData["supporter_number"], card_title: eventData["card_title"], card_type: eventData["card_type"], card_position: eventData["card_position"] }, (eventData["event_category"] ? { event_category: eventData["event_category"] } : {})));
};
export { feedCardView, feedCardInteraction, feedCardClick };
